import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';

import { AccountModule } from './account/account.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { StrikeWalksModule } from './strike-walks/strike-walks.module';
import { StrikesModule } from './strikes/strikes.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AccountModule,
    AppRoutingModule,
    BrowserAnimationsModule, // needed for fade-in/fade-out of toastr notifications 
    BrowserModule,
    FormsModule,
    HttpClientModule,
    LayoutModule,
    ReactiveFormsModule,
    StrikesModule,
    StrikeWalksModule,
    ToastrModule.forRoot({
      "positionClass": "toast-top-right",
      "easeTime": 300,
      "timeOut": 3000,
      "extendedTimeOut": 1000
    })

  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
